class PDPPriceSummary extends HTMLElement {
  constructor() {
    super();

    // Get the target elements
    this.whatsIncludedSection = document.querySelector('.whats-included-section-container');
    console.log('whatsIncludedSection:', this.whatsIncludedSection);
    this.footer = document.querySelector('footer');

    if (!this.whatsIncludedSection || !this.footer) return;

    // Initialize state variables
    this.isWhatsIncludedInView = false;
    this.isFooterInView = false;
    this.hasPassedWhatsIncluded = false;
    this.hasPassedFooter = false;

    console.log('PDPPriceSummary initialized');
    console.log('Whats included section:', this.whatsIncludedSection);
    console.log('Footer:', this.footer);

    // Initially hide the component
    this.classList.add('hide');

    // Force hide on page load
    setTimeout(() => {
      this.classList.add('hide');
    }, 100);

    // Add scroll event listener
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll() {
    const whatsIncludedRect = this.whatsIncludedSection.getBoundingClientRect();
    const footerRect = this.footer.getBoundingClientRect();

    this.isWhatsIncludedInView = whatsIncludedRect.top < window.innerHeight && whatsIncludedRect.bottom >= 0;
    this.isFooterInView = footerRect.top < window.innerHeight && footerRect.bottom >= 0;

    console.log('whatsIncludedRect:', whatsIncludedRect);

    // Determine if we've passed the "What's Included" section
    this.hasPassedWhatsIncluded = whatsIncludedRect.top < 0;
    // Determine if we've passed the footer
    this.hasPassedFooter = footerRect.top < window.innerHeight;

    console.log('isWhatsIncludedInView:', this.isWhatsIncludedInView);
    console.log('isFooterInView:', this.isFooterInView);
    console.log('hasPassedWhatsIncluded:', this.hasPassedWhatsIncluded);
    console.log('hasPassedFooter:', this.hasPassedFooter);

    if (this.hasPassedWhatsIncluded && !this.isFooterInView) {
      // Show the component if we've passed "What's Included" and not reached the footer
      this.classList.remove('hide');
    } else {
      // Hide the component if we're in the "What's Included" section or at the footer
      this.classList.add('hide');
    }
  }

  disconnectedCallback() {
    // Cleanup event listeners when element is removed
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }
}

// Register the web component
customElements.define('pdp-price-summary', PDPPriceSummary);
